<div class="max-width-p">
  <app-notification-banner></app-notification-banner>
  <benefit-header-summary
    headerText="{{
      'FLEXIBLE_FIXED_BENEFITS.FLEXIBLE_BENEFITS_HEADER_TEXT_' + PRICING_PLAN_LABEL[userCompanyInfo.pricingPlan] | translate
    }}"
    smallText="{{
      'FLEXIBLE_FIXED_BENEFITS.FLEXIBLE_BENEFITS_SMALL_TEXT' | translate
    }}"
    [headerType]="offerBenefits?.length > 0 ? 'title-only' : 'full' "
  >
  </benefit-header-summary>

  <ngb-carousel
    [showNavigationIndicators]="true"
    [showNavigationArrows]="true"
    [interval]="10000"
    [pauseOnHover]="false"
    [wrap]="true"
    class="custom-carousel"
    *ngIf="offerBenefits?.length > 0" role="group"
    >
    <ng-template ngbSlide *ngFor="let offer of offerBenefits">
      <div class="carousel-card">
        <div class="carousel-content">
          <div class="offer-image">
            <a [routerLink]="['/' + subdomain + '/flexible-benefits-info/' + offer.providerId + '/' + offer.id]"
            href="javascript:void(0)" class="offer-link"><img [src]="offer.pictureUrl" alt="Offer Image" />
          </a>
          </div>
          <div class="offer-details">
            <h4>{{ offer.name }}</h4>
            <p>{{ 'DETAILS.BENEFIT.PROVIDER' | translate }}  <strong> {{ offer.providerName }}</strong></p>
            <p *ngIf="offer.discountPercentage" class="old-price">
              {{ offer.price / (100 - offer.discountPercentage) * 100 | number:'1.2-2' }} RON
            </p>
            <h4>{{ offer.price }} RON</h4>
            <p class="v-align">
              <a [routerLink]="['/' + subdomain + '/flexible-benefits-info/' + offer.providerId + '/' + offer.id]"
                href="javascript:void(0)" class="offer-link">{{'FLEXIBLE_FIXED_BENEFITS.VIEW_OFFER' | translate}}
              </a>
              <span class="icon-chevron-right feather ficon"></span>
            </p>
          </div>
          <div class="badge-container">
            <div class="decorated-ribbon-badge">
                <div class="ribbon-badge-shadow-yellow"></div>
                <div class="ribbon-badge-back"></div>
                <div class="ribbon-badge-front">
                  <span *ngIf="offer.discountPercentage > 0; else noDiscount">
                    -{{ offer.discountPercentage }}%
                  </span>
                  <ng-template #noDiscount>
                    <span class="icon-gift feather ficon noDiscount"></span>
                  </ng-template>
                </div>
            </div>
        </div>
        </div>
      </div>
    </ng-template>
  </ngb-carousel>

  <div class="row">
    <div class="col-lg-3 sidebar-filters-container">
      <benefit-header-summary
      *ngIf="offerBenefits?.length > 0"
      headerText="{{
        'FLEXIBLE_FIXED_BENEFITS.FLEXIBLE_BENEFITS_HEADER_TEXT' | translate
      }}"
      smallText="{{
        'FLEXIBLE_FIXED_BENEFITS.FLEXIBLE_BENEFITS_SMALL_TEXT' | translate
      }}"
      headerType="card-only"
      >
      </benefit-header-summary>

      <app-benefits-filter [userCompanyInfo]="userCompanyInfo" *ngIf="dataLoadingDone"
                           [applyFiltersBtnEnabled] = "providersOutdated"
                           (changeFilters)="changeFilters($event)"
                           (applyFilters)="applyFilters()"
                           (resetFilters)="resetAllFilters()">
      </app-benefits-filter>
    </div>

    <div class="col-lg-9 flexbile-benefit-cards">
      <div class="flex-column dd">
        <div class="medical-cards">
          <!-- Event supplier cards -->
          <div
            class="card clickable event-card"
            *ngFor="let event of activeEvents"
            (click)="openEventPage(event.id)"
          >
            <div class="align-items-center justify-content-center d-flex voucher-banner-background">
              <img src="{{'DASHBOARD.VOUCHERS.LOGO' | translate}}" alt="" />
            </div>
            <div class="card-body">
              <h4 class="card-title">{{ event.name }}</h4>
              <p class="event-dates font-small-3">
                {{ event.startDate | date: 'dd/MM/yyyy' }} - {{ event.endDate | date: 'dd/MM/yyyy' }}
              </p>
              <a href="javascript:void(0)" class="card-link c-company">
                {{ 'FLEXIBLE_FIXED_BENEFITS.VIEW' | translate }} {{ event.benefits.length }} {{
                  (event.benefits.length > 1
                    ? 'FLEXIBLE_FIXED_BENEFITS.TEXT_OFFERS'
                    : 'FLEXIBLE_FIXED_BENEFITS.TEXT_OFFER') | translate
                }}
                <span class="icon-chevron-right feather ficon"></span>
              </a>
            </div>
          </div>
          <!-- Regular supplier cards -->
          <div
            class="card clickable"
            *ngFor="let providerCard of providersCardInfo"
            (click)="openFlexibleSupplierInfoPage(providerCard.id)"
          >
            <div *ngIf="providerCard.discountPercentage > 0"  class="discount-badge ">
              <span class="badge-text">{{ 'FLEXIBLE_FIXED_BENEFITS.DISCOUNT_PRETEXT' | translate }} -{{ providerCard.discountPercentage}}%</span>
            </div>
            <div class="align-items-center justify-content-center d-flex">
              <div *ngIf="providerCard.pictureUrl; else noPicture">
                <img
                  [src]="providerCard.pictureUrl"
                  [alt]="providerCard.name"
                  width="114"
                  height="97"
                />
              </div>
              <ng-template #noPicture>
                <img src="assets/images/avatars/no-image.jpg" alt=""/>
              </ng-template>
            </div>
            <div class="card-body">
              <h4 class="card-title">{{ providerCard.name }}</h4>
              <a href="javascript:void(0)" class="card-link c-company"
                >{{ 'FLEXIBLE_FIXED_BENEFITS.VIEW' | translate }} {{ providerCard.cntBenefits + ' ' }}
                {{
                  (providerCard.cntBenefits > 1
                    ? 'FLEXIBLE_FIXED_BENEFITS.TEXT_OFFERS'
                    : 'FLEXIBLE_FIXED_BENEFITS.TEXT_OFFER'
                  ) | translate
                }}
                <span class="icon-chevron-right feather ficon"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center load-more-container">
        <button *ngIf="providersCardInfo.length < totalProviders" class="btn btn-secondary bold" (click)="loadMoreProviders()">
          {{ 'FLEXIBLE_FIXED_BENEFITS.LOAD_MORE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
